"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFieldsData = exports.parseFormData = void 0;
const mobx_1 = require("mobx");
const lodash_1 = __importDefault(require("lodash"));
const props_1 = require("./props");
const parseFormData = form => (0, mobx_1.toJS)(lodash_1.default.pick(form, props_1.formPropsToPick));
exports.parseFormData = parseFormData;
const getObservableMapValues = observableMap => mobx_1.values
    ? (0, mobx_1.values)(observableMap)
    : observableMap.values();
const parseFieldsData = fields => lodash_1.default.reduce(getObservableMapValues(fields), (obj, field) => {
    const $nested = $fields => ($fields.size !== 0)
        ? parseFieldsData($fields)
        : undefined;
    const data = (0, mobx_1.toJS)(lodash_1.default.pick(field, props_1.fieldPropsToPick));
    Object.assign(obj, {
        [field.key]: Object.assign(data, {
            fields: $nested(field.fields),
        }),
    });
    return obj;
}, {});
exports.parseFieldsData = parseFieldsData;
